import { render, staticRenderFns } from "./Preaspirantes.vue?vue&type=template&id=fa100aba&scoped=true"
import script from "./Preaspirantes.vue?vue&type=script&lang=js"
export * from "./Preaspirantes.vue?vue&type=script&lang=js"
import style0 from "./Preaspirantes.vue?vue&type=style&index=0&id=fa100aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa100aba",
  null
  
)

export default component.exports